export default {
  // 时间转换 yyyy-MM-dd HH-mm-ss
  transDate(time) {
    return new Promise((resolve, reject) => {
      if(!time) return resolve(undefined);
      let date = new Date(time);
      let yyyy = date.getFullYear() + '-';
      let MM = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
      let dd = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' ';
      let HH = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
      let mm = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
      let ss = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());
      resolve(yyyy + MM + dd + HH + mm + ss);
    });
  },
  // 时间转换 yyyy-MM-dd HH-mm-ss
  transDateRes(time) {
    if(!time) return undefined;
    let date = new Date(time);
    let yyyy = date.getFullYear() + '-';
    let MM = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
    let dd = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' ';
    let HH = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
    let mm = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
    let ss = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());
    return yyyy + MM + dd + HH + mm + ss;
  },
  // 文件大小转换
  fileSizeFloat(size,num) {
    size = size || 0
    num = num || 2;
    const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let unitIndex = 0;
    while (size >= 1024 && unitIndex < units.length - 1) {
      size /= 1024;
      unitIndex++;
    }
    if(num==0) {
      parseFloat
      return parseInt(size) + ' ' + units[unitIndex];
    } else {
      return size.toFixed(num) + ' ' + units[unitIndex];
    }
  },
  // 文件大小转换
  fileSizeHandle(size) {
    size = size || 0
    const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let unitIndex = 0;
    while (size >= 1024 && unitIndex < units.length - 1) {
      size /= 1024;
      unitIndex++;
    }
    let sizeFixed2 = size.toFixed(2)
    let sub = sizeFixed2.slice(-2)
    if(sub=='00') {
      return parseInt(sizeFixed2) + ' ' + units[unitIndex];
    } else {
      return sizeFixed2 + ' ' + units[unitIndex];
    }
  },
  // 文件大小转换为 GB
  fileSizeChange(limit,num) {
    var size = "";
    num = num || 2;
    size = (limit / (1024 * 1024 * 1024)).toFixed(num)
    var sizeStr = size + "";                        //转成字符串
    var index = sizeStr.indexOf(".");                    //获取小数点处的索引
    var dou = sizeStr.substr(index + 1, 2)            //获取小数点后两位的值
    if (dou == "00") {                                //判断后两位是否为00，如果是则删除00
      return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2)
    }
    return size;
  },

  // 时间戳转时分秒
  transDateTime(timestamp,type) {
    let day = '', hr = '', min = '', sec = '';
    let second = Math.floor(timestamp / 1000);  // 总秒数
    day = Math.floor(second / 3600 / 24);       // 天数
    hr = Math.floor(second / 3600 % 24);        // 小时
    if(type) {
      min = Math.floor(second / 60 % 60);       // 分钟
      sec = Math.floor(second % 60);            // 秒
      return (day?day + "天":'') + (hr?hr+ "时":'') + ( min?min + "分":'');
      // return (day?day + "天":'') + (hr?hr+ "时":'') + ( min?min + "分":'') + sec + "秒";
    } else {
      return (day?day + "天":'') + (hr?hr+ "时":'');
    }
  },
  // GB转字节
  gigabytesToBytes(gb) {
    const bytesInGigabyte = 1073741824; // 1GB = 1073741824 bytes
    return gb * bytesInGigabyte;
  },
}



// WEBPACK FOOTER //
// ./src/utils/public.js